/* eslint-disable prefer-rest-params */
export default function stickyHeader() {
  let scrollPos = 0;
  const nav = document.querySelector('.site-header-sticky');
  function checkHeaderPosition() {
    const windowY = window.scrollY;
    if (scrollPos < window.innerHeight) {
      nav.classList.remove('is-initial');
      nav.classList.add('is-hidden');
      nav.classList.remove('is-visible');
    } else {
      nav.classList.remove('is-initial');
      nav.classList.add('is-visible');
      nav.classList.remove('is-hidden');
    }
    scrollPos = windowY;
  }
  function debounce(func, wait = 10, immediate = true) {
    let timeout;
    return function debouncer() {
      const context = this;
      const args = arguments;
      const later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  window.addEventListener('scroll', debounce(checkHeaderPosition));
}
